
import { Options, Vue } from "vue-class-component";
import {
  DryGasSealType,
  EquipmentComment,
  FailureType,
  InformationType,
} from "../../types/equipment-comment";
import { EquipmentSystem } from "../../types/equipment-model";
import EquipmentStatusSelector from "../equipment-status/EquipmentStatusSelector.vue";
import QualityKpi from "./QualityKpi.vue";
import { formatDateWithoutHours } from "../../helpers/equipment-status-helpers";
import { mapGetters } from "vuex";
import { Equipment } from "@/types/equipment";
import { convertEnumFailureType } from "@/helpers/equipment-comment-helper";
import _ from "lodash";
import { ref } from "vue";

@Options({
  computed: {
    ...mapGetters(["getEquipmentDetails"]),
    // groupedData() {
    //   const itemsPerPage = 3;
    //   return this.slides.reduce((result, item, index) => {
    //     const slideIndex = Math.floor(index / itemsPerPage);
    //     if (!result[slideIndex]) {
    //       result[slideIndex] = [];
    //     }
    //     result[slideIndex].push(item);
    //     if(result.length === 3){
    //       let combineData = {data:{}};
    //       combineData.data = result;
    //       return combineData;
    //     }
    //     return result;
    //   }, []);
    // },
  },
  data() {
    return {
      arrows: ref(true),
      controlType: ref("outline"),
      //slide: 0,
      slide: ref("content-1"),
      // slides: [
      //   {
      //     title: "Temperature",
      //     slideData: {
      //       thirty_days: [{
      //         a_type: "real",
      //         a_data: 2
      //       }],
      //       year: [{
      //         a_type: "real",
      //         a_data: 3
      //       }]
      //     },
      //   },
      //   {
      //     title: "Low pressure",
      //     slideData: {
      //       thirty_days: [{
      //         a_type: "real",
      //         a_data: 1
      //       },
      //       {
      //         a_type: "false",
      //         a_data: 1
      //       }],
      //       year: [{
      //         a_type: "real",
      //         a_data: 1
      //       },
      //       {
      //         a_type: "false",
      //         a_data: 1
      //       }]
      //     },
      //   },
      //   {
      //     title: "Vibration",
      //     slideData: {
      //       thirty_days: [{
      //         a_type: "real",
      //         a_data: 1
      //       }],
      //       year: [{
      //         a_type: "real",
      //         a_data: 1
      //       },
      //       {
      //         a_type: "false",
      //         a_data: 1
      //       }]
      //     },
      //   },
      //   {
      //     title: "Temperature",
      //     slideData: {
      //       thirty_days: [{
      //         a_type: "real",
      //         a_data: 2
      //       }],
      //       year: [{
      //         a_type: "real",
      //         a_data: 3
      //       }]
      //     },
      //   },
      //   {
      //     title: "Low pressure",
      //     slideData: {
      //       thirty_days: [{
      //         a_type: "real",
      //         a_data: 1
      //       },
      //       {
      //         a_type: "false",
      //         a_data: 1
      //       }],
      //       year: [{
      //         a_type: "real",
      //         a_data: 1
      //       },
      //       {
      //         a_type: "false",
      //         a_data: 1
      //       }]
      //     },
      //   },
      //   {
      //     title: "Vibration",
      //     slideData: {
      //       thirty_days: [{
      //         a_type: "real",
      //         a_data: 1
      //       }],
      //       year: [{
      //         a_type: "real",
      //         a_data: 1
      //       },
      //       {
      //         a_type: "false",
      //         a_data: 1
      //       }]
      //     },
      //   },
      //   {
      //     title: "Temperature",
      //     slideData: {
      //       thirty_days: [{
      //         a_type: "real",
      //         a_data: 2
      //       }],
      //       year: [{
      //         a_type: "real",
      //         a_data: 3
      //       }]
      //     },
      //   },
      // ]
    };
  },
  props: {
    equipment: {
      type: Object,
      required: false,
    },
  },
  components: {
    EquipmentStatusSelector,
    QualityKpi,
  },
  name: "StatusCurrentCard",
})
export default class StatusCard extends Vue {
  informationType = InformationType;
  equipmentSystem = EquipmentSystem;
  dryGasSealType = DryGasSealType;
  getEquipmentDetails!: Equipment;
  failureTypologies?: string;
  informationTypeEnum = InformationType;
  slides: [];
  groupedData: [];
  formatDate(date: Date): string {
    return formatDateWithoutHours(date);
  }

  get getLastFailureType(): string | undefined {
    const commentsFiltered = _.orderBy(
      _.filter(
        this.getEquipmentDetails?.equipmentComments,
        (comment: EquipmentComment) => {
          return comment.informationType == this.informationTypeEnum.OIL;
        }
      ),
      "date",
      "desc"
    );
    if (commentsFiltered.length > 0 && commentsFiltered[0].failureType) {
      const failureTypes = commentsFiltered[0].failureType?.map(
        (failureType: FailureType) => {
          return convertEnumFailureType(failureType);
        }
      );
      this.failureTypologies = failureTypes?.join(", ");
    } else {
      this.failureTypologies = "No failure identified";
    }
    return this.failureTypologies;
  }
}
